import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { BaseComponent } from '../base/base.component';
import { StringTableService } from '../../services/string-table.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends BaseComponent implements OnInit {

  private isLoggedIn = true;

  public logoImgSrc = 'assets/img/logo-small.png';
  public titleText = this.stringTableService.getString('header','title');

  constructor(
    public elementRef: ElementRef,
    private router: Router,
    private loginService: LoginService,
    protected stringTableService: StringTableService
  ) {
    super(elementRef);
  }

  ngOnInit() {

  }

  onClick(type: TYPE) {
    if (TYPE.LOGOUT === type) {
      this.loginService.logout();
    }
  }

}

enum TYPE {
  LOGOUT = 0
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/header/header.component.ts